
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.057 4.442H.53a.515.515 0 00-.514.514v9.53c0 .283.23.514.514.514h2.528c.284 0 .514-.23.514-.514v-9.53a.515.515 0 00-.514-.514zm-.366 9.678H.895V5.322H2.69v8.798zM1.793 0C.804 0 0 .804 0 1.793c0 .989.804 1.793 1.793 1.793.989 0 1.793-.804 1.793-1.793C3.586.804 2.782 0 1.793 0zm0 2.706a.914.914 0 010-1.826.914.914 0 010 1.826zM11.75 5.56a3.28 3.28 0 00-2.164-.76c-.49.009-.97.127-1.404.341v-.208c0-.27-.22-.49-.491-.49H5.116c-.271 0-.491.22-.491.49v9.576c0 .271.22.491.49.491h2.626a.44.44 0 00.44-.44V8.85a.91.91 0 01.872-.916.9.9 0 01.925.898v5.737c0 .238.193.431.43.431h2.524a.43.43 0 00.43-.43V9.005c0-1.334-.587-2.59-1.613-3.446zm.733 8.56h-1.625V8.832A1.78 1.78 0 009.08 7.053 1.78 1.78 0 007.3 8.832v5.288H5.505V5.322h1.796v.64h.001a.44.44 0 00.731.33c.434-.384.991-.602 1.57-.612a2.398 2.398 0 011.582.555 3.6 3.6 0 011.298 2.771v5.114z"}})])
          )
        }
      }
    